export default {
  namespaced: true,
  state: {
    id: 0,
    childModuleId: 0,
    name: ''
  }
}
